import React from 'react';
import PropTypes from 'prop-types';

const EstatePlanningNotes = (props) => {
  const { notes } = props;

  return (
    <div className="estate-planning-notes">
      <h4>Estate Planning Notes</h4>
      {notes !== '' ? <p>{notes}</p> : <p>No estate planning notes.</p>}
    </div>
  );
};

EstatePlanningNotes.propTypes = {
  notes: PropTypes.string,
};

EstatePlanningNotes.defaultProps = {
  notes: '',
};

export default EstatePlanningNotes;
